module.exports = __webpack_public_path__ + "img/product-preview-4.7cdadfd.png";